"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _fluxActions = require("flux-actions");

var _immutable = require("immutable");

var ActionTypes = _interopRequireWildcard(require("MeetingsLib/redux/actions/ActionTypes"));

var _LegalConsentOptions = _interopRequireDefault(require("MeetingsBase/models/LegalConsentOptions"));

var _LegalCommunicationConsent = _interopRequireDefault(require("MeetingsLib/models/LegalCommunicationConsent"));

var _legalConsent = require("MeetingsBase/constants/legalConsent");

var _handleActions;

var initialState = (0, _immutable.List)();

var _default = (0, _fluxActions.handleActions)((_handleActions = {}, (0, _defineProperty2.default)(_handleActions, ActionTypes.PUBLIC_AVAILABILITY_INFO_FETCH_SUCCEEDED, function (state, action) {
  if (state.size === 0) {
    var legalConsentOptions = _LegalConsentOptions.default.from(action.payload.bookInfo.customParams.legalConsentOptions);

    var subscriptions = legalConsentOptions.getSubscriptions();
    return subscriptions.map(function (subscription) {
      var _LegalCommunicationCo;

      return new _LegalCommunicationConsent.default((_LegalCommunicationCo = {}, (0, _defineProperty2.default)(_LegalCommunicationCo, _legalConsent.CHECKBOX_KEYS.COMMUNICATION_TYPE_ID, subscription.communicationTypeId), (0, _defineProperty2.default)(_LegalCommunicationCo, "consented", false), (0, _defineProperty2.default)(_LegalCommunicationCo, "required", subscription.required), _LegalCommunicationCo));
    });
  }

  return state;
}), (0, _defineProperty2.default)(_handleActions, ActionTypes.SET_GIVEN_CONSENT, function (state, action) {
  var indexToUpdate = state.findIndex(function (checkbox) {
    return checkbox[_legalConsent.CHECKBOX_KEYS.COMMUNICATION_TYPE_ID] === action[_legalConsent.CHECKBOX_KEYS.COMMUNICATION_TYPE_ID];
  });
  return state.setIn([indexToUpdate, 'consented'], action.consented);
}), (0, _defineProperty2.default)(_handleActions, ActionTypes.RESET_CONSENT_RESPONSES, function (state) {
  return state.map(function (checkbox) {
    return checkbox.set('consented', false);
  });
}), _handleActions), initialState);

exports.default = _default;
module.exports = exports.default;